<script lang="ts" context="module">
  import { getAppConfig } from '../../../common/config/app-config';
  import { CONSTANTS } from '../../../common/config/constants';
  import { getJoodDayBannerDetails } from '../../../common/joodUtils';
  import { getJoodMembershipType, getStr, type JoodMembershipType } from '../../../common/util';

  const { extraThemeResourcePath, primeLevel, joodFullCappingLimitReached } = getAppConfig();
  let userJoodMembershipType: JoodMembershipType = getJoodMembershipType();
  const { VIPPRIME } = CONSTANTS;
</script>

<script lang="ts">
  import { getBottomTags } from '../../brand/services/brand-data-services';
  import ProductTileJoodWalletCreditAmount from '../../common/components/productTile/components/ProductTileJoodWalletCreditAmount.svelte';
  import { ProductTilePriceGroupVariantType } from '../../common/components/productTile/product-tile-main';

  import Icon from '../../common/components/Icon.svelte';
  import TimerTag from '../../common/components/tag/TimerTag.svelte';

  export let creditPoints;
  export let algoliaProductHit;
  export let variant: ProductTilePriceGroupVariantType;

  const theme = getJoodDayBannerDetails(userJoodMembershipType);

  const endDateJoodDay = algoliaProductHit?.endDateJoodDay;
  const dealObj = { endDateDeal: endDateJoodDay };
  const bottomTags = { tagsData: getBottomTags(dealObj) };
  const tagData = { product: bottomTags.tagsData[0].product };
  const isJoodDeal = endDateJoodDay ? true : false;
</script>

{#if creditPoints > 0 && !joodFullCappingLimitReached}
  <section
    class="{variant === 'pdp-popup'
      ? 'variant-pdp'
      : ''} c_product-price-jood-wallet-container c_jooddaywalletcard c_jood-wallet-benefit-container variant-{variant} {primeLevel
      ? 'user-PRIME'
      : 'user-NOPRIME'}"
    style:background-image="url({theme.backgroundImage})"
    style:color={theme.textColor}
    style:border={`1px solid ${theme.borderColor}`}
  >
    <section class="banner-logo">
      <img src={theme.foregroundImage} alt="" />

      {#if isJoodDeal}
        <div class="c_joodtimer" style="color:{theme?.timerTextColor};">
          <Icon type="font" glyph="working-hours" mobileSize={15} desktopSize={18} />
          <section class="c_jooddealtime" style="color:{theme?.timerTextColor}">
            <TimerTag {...tagData} {isJoodDeal} />
          </section>
        </div>
      {:else}
        <div class="jood-day-timer">
          <img src={`${extraThemeResourcePath}/images/jood/extra-calender.svg`} alt="" />
          <span>{getStr('extra.price.today.only.text')}</span>
        </div>
      {/if}
    </section>
    <div class="middle">
      <ProductTileJoodWalletCreditAmount isTacticalFlag={true} {creditPoints} {variant} priceType={VIPPRIME} {theme} />
    </div>
  </section>
{/if}
